// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"0e00c703","453":"670e15c7","536":"6abca2b2","684":"2d53e2ba"}[chunkId] + ".chunk.js";
};